/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMetadata = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m13.414 2 8.964 8.964-10.3 11.444L2 13.449V2zm-.83 1.999H4v8.552l7.921 7.041 7.7-8.556zM10 11v1.999L12 13v2H8v-4zm5-3v4h-2V9.999L11 10V8zM8 6v2H6V6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMetadata as Metadata };
